import {Component, Input, Output, EventEmitter, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl, Validator} from '@angular/forms';
const _ = require('lodash');

@   Component({
    selector: 'tags',
    template: require('./tags.html'),
    styles: [require('./tags.scss')],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => Tags),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => Tags),
            multi: true,
        }]
})

export class Tags implements ControlValueAccessor {

    @Input() zoneTags: any;
    @Input() readOnly: boolean = false;
    @Output() tags = new EventEmitter();

    private tagsArray: Array<string>;
    private newTag: string = '';
    private data: any;

    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    public registerOnChange(fn: any) {
    }

    // not used, used for touch input
    public registerOnTouched() {
    }

    ngOnInit() {
        this.tagsArray = this.zoneTags.slice(0);
    }

    add() {
        if (this.newTag) {
            this.tagsArray.push(this.newTag);
            this.newTag = '';
            this.tags.emit(this.tagsArray);
        }
    }

    remove(tag, i: number) {
        this.tagsArray.splice(i, 1);
        this.tags.emit(this.tagsArray);
    }

    writeValue(obj) {
        if (obj) {
            this.data = obj;
            this.tagsArray = this.data;
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/tags/tags.component.ts